import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

type Props = {
  onShowForm?: () => void

  textDirection?: string
  direction?: string
}

export const SearchParams = ({
  onShowForm,
  textDirection,
  direction,
}: Props) => {
  return (
    <div
      className={s.content}
      onClick={onShowForm}
    >
      <div className={s.left}>
        <div className={s.direction}>{direction}</div>

        <div className={s.info}>{textDirection}</div>
      </div>

      <AppIcon
        className={s.loop}
        id={AllIcons.LOOP}
      />
    </div>
  )
}
